/*
 * strova core
 * Progressive Enhancement fuer Navigation, Galerie, Video, Mengen-/Bundle-Auswahl,
 * Varianten, Sticky Add to Cart und Lightbox.
 * Greift nicht in Formularabsendungen, Warenkorbberechnung oder Checkout ein.
 */
(function () {
  'use strict';

  var strova = (window.strova = window.strova || {});

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, opener) {
    var previous = opener || document.activeElement;

    function onKeydown(event) {
      if (event.key !== 'Tab') return;
      var nodes = Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (node) {
        return node.offsetParent !== null;
      });
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKeydown);
    var target = container.querySelector(FOCUSABLE);
    if (target) target.focus();

    return function release() {
      container.removeEventListener('keydown', onKeydown);
      if (previous && typeof previous.focus === 'function') previous.focus();
    };
  }
  strova.trapFocus = trapFocus;

  var openLayers = [];

  function unlockScroll() {
    if (!openLayers.length) document.documentElement.style.overflow = '';
  }

  strova.openLayer = function (element, openClass, opener) {
    element.hidden = false;
    element.classList.add(openClass || 'is-open');
    var release = trapFocus(element, opener);
    var layer = { element: element, release: release, openClass: openClass || 'is-open' };
    openLayers.push(layer);
    document.documentElement.style.overflow = 'hidden';
    return layer;
  };

  strova.closeLayer = function (layer) {
    if (!layer) return;
    layer.element.classList.remove(layer.openClass);
    layer.element.hidden = true;
    layer.release();
    openLayers = openLayers.filter(function (item) { return item !== layer; });
    unlockScroll();
  };

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !openLayers.length) return;
    strova.closeLayer(openLayers[openLayers.length - 1]);
  });

  /* Eigene strova-Ereignisse. Niemals Commerce-Ereignisse — die gehoeren
     ausschliesslich Shopify und der offiziellen Meta-Integration. */
  strova.track = function (name, payload) {
    if (!strova.customEventsEnabled) return;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload || {});
      }
    } catch (error) { /* Tracking darf die Seite nie blockieren. */ }
  };

  /* -------------------------------------------------------- mobile nav */

  function initNav(scope) {
    var nav = scope.querySelector('[data-st-nav]');
    if (!nav || nav.dataset.stReady) return;
    nav.dataset.stReady = '1';

    var opener = scope.querySelector('[data-st-nav-open]');
    var layer = null;

    function open() {
      layer = strova.openLayer(nav, 'is-open', opener);
      nav.setAttribute('open', '');
      if (opener) opener.setAttribute('aria-expanded', 'true');
    }
    function close() {
      nav.removeAttribute('open');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      strova.closeLayer(layer);
      layer = null;
    }

    if (opener) opener.addEventListener('click', open);
    nav.querySelectorAll('[data-st-nav-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });
  }

  /* ------------------------------------------------------------- video */

  function initVideos(scope) {
    scope.querySelectorAll('[data-st-video]').forEach(function (slot) {
      if (slot.dataset.stReady) return;
      slot.dataset.stReady = '1';
      var play = slot.querySelector('[data-st-video-play]');
      var template = slot.querySelector('[data-st-video-source]');
      if (!play || !template) return;

      play.addEventListener('click', function () {
        slot.appendChild(template.content.cloneNode(true));
        slot.classList.add('is-playing');
        var video = slot.querySelector('video');
        if (video) {
          video.muted = true;
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {});
        }
      });
    });
  }

  /* ----------------------------------------------------------- gallery */

  function initGallery(scope) {
    scope.querySelectorAll('[data-st-gallery]').forEach(function (gallery) {
      if (gallery.dataset.stReady) return;
      gallery.dataset.stReady = '1';

      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-st-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-st-thumb]'));
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-st-gallery-dot]'));
      var position = gallery.querySelector('[data-st-gallery-position]');
      var label = gallery.querySelector('[data-st-gallery-label]');
      var track = gallery.querySelector('[data-st-gallery-track]');
      var desktop = window.matchMedia('(min-width: 990px)');

      function setActive(index) {
        if (index < 0 || index >= slides.length) return;
        if (desktop.matches) {
          slides.forEach(function (slide, i) { slide.hidden = i !== index; });
        }
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
        if (position) position.textContent = index + 1 + ' / ' + slides.length;
        if (label) label.textContent = slides[index].dataset.mediaLabel || '';
      }

      function syncFromScroll() {
        if (!track || desktop.matches) return;
        var index = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.min(index, slides.length - 1));
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          setActive(index);
          if (!desktop.matches && track) {
            track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
          }
        });
      });

      if (track) track.addEventListener('scroll', syncFromScroll, { passive: true });
      desktop.addEventListener('change', function () {
        slides.forEach(function (slide) { slide.hidden = false; });
        setActive(0);
      });

      slides.forEach(function (slide) { slide.hidden = false; });
      setActive(0);

      gallery.addEventListener('strova:variant', function (event) {
        var mediaId = event.detail && event.detail.mediaId;
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].dataset.mediaId) === String(mediaId)) {
            setActive(i);
            if (track && !desktop.matches) track.scrollTo({ left: track.clientWidth * i });
            break;
          }
        }
      });
    });
  }

  /* ------------------------------------------- Mengen-/Bundle-Auswahl */

  function initBundle(scope) {
    scope.querySelectorAll('[data-st-bundle]').forEach(function (bundle) {
      if (bundle.dataset.stReady) return;
      bundle.dataset.stReady = '1';

      var form = bundle.closest('form');
      var quantityInput = form ? form.querySelector('[data-st-quantity]') : null;
      var options = Array.prototype.slice.call(bundle.querySelectorAll('.st-bundle__option'));

      function select(option) {
        options.forEach(function (item) { item.classList.toggle('is-selected', item === option); });
        var input = option.querySelector('input');
        if (input) input.checked = true;
        if (quantityInput) quantityInput.value = option.dataset.quantity || '1';
        bundle.dispatchEvent(new CustomEvent('strova:bundle', {
          bubbles: true,
          detail: { quantity: option.dataset.quantity }
        }));
      }

      options.forEach(function (option) {
        var input = option.querySelector('input');
        if (input) input.addEventListener('change', function () { select(option); });
      });

      var preselected = bundle.querySelector('.st-bundle__option.is-selected') || options[0];
      if (preselected) select(preselected);
    });
  }

  /* ---------------------------------------------------- variant picker */

  function initVariants(scope) {
    scope.querySelectorAll('[data-st-variant-picker]').forEach(function (picker) {
      if (picker.dataset.stReady) return;
      picker.dataset.stReady = '1';

      var root = picker.closest('[data-st-product]');
      if (!root) return;
      var dataNode = root.querySelector('[data-st-variant-data]');
      if (!dataNode) return;

      var variants = JSON.parse(dataNode.textContent || '[]');
      var idInput = root.querySelector('[data-st-variant-id]');
      var priceNode = root.querySelector('[data-st-buybox-price]');
      var saleBadge = root.querySelector('[data-st-sale-badge]');
      var submit = root.querySelector('[data-st-add-to-cart]');
      var soldOut = root.querySelector('[data-st-sold-out]');
      var gallery = document.querySelector('[data-st-gallery]');
      var stickyPrice = document.querySelector('[data-st-sticky-price]');
      var stickyName = document.querySelector('[data-st-sticky-variant]');

      function update() {
        var selection = Array.prototype.map.call(picker.querySelectorAll('input:checked'), function (input) {
          return input.value;
        });
        var match = variants.filter(function (variant) {
          return variant.options.every(function (value, index) { return value === selection[index]; });
        })[0];
        if (!match) return;

        if (idInput) idInput.value = match.id;
        if (priceNode) priceNode.innerHTML = match.price_html;
        if (saleBadge) saleBadge.hidden = !match.on_sale;
        if (stickyPrice) stickyPrice.textContent = match.price;
        if (stickyName && match.title) stickyName.textContent = match.title;

        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? submit.dataset.labelAvailable : submit.dataset.labelSoldOut;
        }
        if (soldOut) soldOut.hidden = match.available;

        if (gallery && match.media_id) {
          gallery.dispatchEvent(new CustomEvent('strova:variant', { detail: { mediaId: match.media_id } }));
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
    });
  }

  /* -------------------------------------------------------- sticky ATC */

  function initStickyAtc(scope) {
    var sticky = scope.querySelector('[data-st-sticky-atc]');
    if (!sticky || sticky.dataset.stReady) return;
    sticky.dataset.stReady = '1';

    var anchor = document.querySelector('[data-st-buybox]');
    if (!anchor) return;

    var button = sticky.querySelector('[data-st-sticky-submit]');
    if (button) {
      button.addEventListener('click', function () {
        var form = document.querySelector('[data-st-product-form]');
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    function setVisible(visible) { sticky.classList.toggle('is-visible', visible); }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    } else {
      window.addEventListener('scroll', function () {
        setVisible(anchor.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    document.addEventListener('strova:drawer', function (event) {
      sticky.hidden = !!(event.detail && event.detail.open);
    });
  }

  /* ---------------------------------------------------------- lightbox */

  function initLightbox(scope) {
    var lightbox = document.querySelector('[data-st-lightbox]');
    if (!lightbox) return;

    var image = lightbox.querySelector('[data-st-lightbox-image]');
    var caption = lightbox.querySelector('[data-st-lightbox-caption]');
    var counter = lightbox.querySelector('[data-st-lightbox-counter]');
    var items = [];
    var index = 0;
    var layer = null;

    function render() {
      var item = items[index];
      if (!item) return;
      image.src = item.src;
      image.alt = item.alt || '';
      if (caption) caption.textContent = item.caption || '';
      if (counter) counter.textContent = index + 1 + ' / ' + items.length;
    }

    if (!lightbox.dataset.stReady) {
      lightbox.dataset.stReady = '1';
      lightbox.querySelectorAll('[data-st-lightbox-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          strova.closeLayer(layer);
          layer = null;
        });
      });
      var prev = lightbox.querySelector('[data-st-lightbox-prev]');
      var next = lightbox.querySelector('[data-st-lightbox-next]');
      if (prev) prev.addEventListener('click', function () {
        index = (index - 1 + items.length) % items.length;
        render();
      });
      if (next) next.addEventListener('click', function () {
        index = (index + 1) % items.length;
        render();
      });
    }

    scope.querySelectorAll('[data-st-lightbox-group]').forEach(function (group) {
      if (group.dataset.stReady) return;
      group.dataset.stReady = '1';
      var triggers = Array.prototype.slice.call(group.querySelectorAll('[data-st-lightbox-open]'));
      triggers.forEach(function (trigger, position) {
        trigger.addEventListener('click', function () {
          items = triggers.map(function (node) {
            return {
              src: node.dataset.full || '',
              alt: node.dataset.alt || '',
              caption: node.dataset.caption || ''
            };
          });
          index = position;
          render();
          layer = strova.openLayer(lightbox, 'is-open', trigger);
        });
      });
    });
  }

  function init(scope) {
    var root = scope || document;
    initNav(root);
    initVideos(root);
    initGallery(root);
    initBundle(root);
    initVariants(root);
    initStickyAtc(root);
    initLightbox(root);
  }

  strova.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
